module.exports = __webpack_public_path__ + "static/media/cloud-done-editor.6b78d687.svg";